<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows p-datatable-no-header">
        <p-table [(first)]="first" [(rows)]="rows" [paginator]="true" [value]="machineSubscriptions"
                 [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalSubscriptions"
                 sortField="subscription.startDate" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.startDate' | transloco}}</th>
              <th scope="col">{{'attribute.endDate' | transloco}}</th>
              <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
              <th scope="col">{{'attribute.status' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template let-machineSubscription pTemplate="body">
            <tr *ngIf="!loadingSubscriptions">
              <td>{{machineSubscription.startDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}</td>
              <td>{{machineSubscription.endDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}</td>
              <td><a
                [routerLink]="['/machines', machineSubscription.machineUuid, 'details']">{{machineSubscription.serial}}</a>
              </td>
              <td *ngIf="machineSubscription.active">{{'attribute.statusActive' | transloco}}</td>
              <td *ngIf="!machineSubscription.active">{{'attribute.statusInactive' | transloco}}</td>
            </tr>
            <tr *ngIf="loadingSubscriptions">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalSubscriptions == 0"
                 class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
            <div *ngIf="totalSubscriptions > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalSubscriptions ? totalSubscriptions : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalSubscriptions}}
              {{(totalSubscriptions > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
